import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModeService } from './common/services/app.mode.service';
// import {} from '@types/googlemaps';
// import {} from 'facebook-js-sdk';

import { AppModule } from './components/app/app.module';

if (!AppModeService.isDevelopmentMode) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(console.error);



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/main.ts